import { IndexPage } from './IndexPage';
import { DetailPage, AssignedOffers, AssignedGames, OffersOverview, CampaignStatistics } from './DetailPage';
import { GamesSelectionPage, AssignedGamesSelectionPage, UnassignedGamesSelectionPage } from './GamesSelectionPage';
import { DefaultCampaignPage } from './DefaultCampaignPage';
import { OfferDetailPage } from './OfferDetailPage';
import { OfferDashboard } from './OfferDashboard';

export {
    IndexPage,
    DetailPage,
    GamesSelectionPage,
    DefaultCampaignPage,
    AssignedOffers,
    AssignedGames,
    OffersOverview,
    CampaignStatistics,
    AssignedGamesSelectionPage,
    UnassignedGamesSelectionPage,
    OfferDetailPage,
    OfferDashboard
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/FreeRoundCampaigns/index.ts
 **/